/** Marketing copy + fallbacks when subscription_plans.features is empty. */

export const FREE_TRIAL_PROGRAM_LIMIT = 3;
export const FREE_TRIAL_POST_LIMIT = 2;
export const FREE_TRIAL_TOTAL_LIMIT = 5;

export const FREE_TRIAL_FEATURES = [
  "5 listings included (3 programs + 2 posts)",
  "Create an account & institution profile",
  "Basic listing & campus timeline",
] as const;

export const PRO_PLUS_FEATURES = [
  "Unlimited program listings",
  "Unlimited campus posts & announcements",
  "Direct contact with student followers",
  "Featured placement on Discover",
  "Performance & lead analytics",
  "Priority support",
  "Higher search ranking",
] as const;

export function planFeatureList(
  features: unknown,
  fallback: readonly string[]
): string[] {
  if (Array.isArray(features) && features.length > 0) {
    return features.map(String).filter((f) => !/campaign duration/i.test(f));
  }
  return [...fallback];
}

export function isPartnerProPlus(subscription: {
  status?: string | null;
  plan?: { name?: string | null } | null;
} | null): boolean {
  if (!subscription?.plan?.name) return false;
  if (subscription.plan.name !== "Pro+") return false;
  const status = (subscription.status || "").toLowerCase();
  return status === "active" || status === "trial";
}
